export * from './base-crud.component';
export * from './base-crud-navigation.component';
export * from './base-info.component';
export * from './base-list.component';
export * from './base-list-filter.component';
export * from './base-step.component';
export * from './base.component';
export * from './base-crud-navigation-profissional.component';
export * from './base-barprogress.component';


// WEBPACK FOOTER //
// ./src/app/base/index.ts